import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  CheckBox,
  CheckBoxAcceptLabel,
  CheckBoxTitleLabel,
  CheckBoxWrapper,
} from './CheckBoxField.styled';
import { TooltipError } from '@components/atoms/Tooltip/Tooltip.styled';

const CheckBoxField = ({
  id,
  name,
  required,
  isConsentBox,
  label,
  className,
  onClick,
  isChecked,
}) => {
  const [isInvalid, setIsInvalid] = useState(false);
  const [checked, setChecked] = useState(isChecked);

  const invalid = (event) => {
    setIsInvalid(event.type && event.type === 'invalid');
  };

  const handleClick = (event) => {
    onClick(event);
    setChecked(!checked);
    if (required) {
      setIsInvalid(checked);
    }
  };

  return (
    <CheckBoxWrapper data-testid={`ckeckbox_${id}`}>
      <CheckBox
        name={name}
        required={required}
        id={id}
        type="checkbox"
        className={className}
        checked={checked}
        $iserror={isInvalid}
        onChange={handleClick.bind(this)}
        onInvalid={invalid.bind(this)}
      />
      {(isInvalid && (
        <TooltipError
          data-testid={`ckeckbox_error_${id}`}
          $content="Ce champ est requis."
        />
      )) || <></>}
      {(isConsentBox && (
        <CheckBoxAcceptLabel htmlFor={id} $iserror={isInvalid}>
          {label}
        </CheckBoxAcceptLabel>
      )) || (
        <CheckBoxTitleLabel htmlFor={id} $iserror={isInvalid}>
          {label}
        </CheckBoxTitleLabel>
      )}
    </CheckBoxWrapper>
  );
};

CheckBoxField.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  isConsentBox: PropTypes.bool,
  required: PropTypes.bool.isRequired,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  isChecked: PropTypes.bool,
};

export default CheckBoxField;
